import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-share",
  "use": "icon-share-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-share\"><defs><style type=\"text/css\"></style></defs><path d=\"M809.890909 879.709091H116.363636V186.181818h344.436364V116.363636H79.127273c-18.618182 0-32.581818 18.618182-32.581818 37.236364v763.345455c0 18.618182 13.963636 32.581818 32.581818 32.581818h763.345454c18.618182 0 32.581818-13.963636 32.581818-32.581818v-367.709091h-69.818181v330.472727z\" p-id=\"1837\" /><path d=\"M944.872727 74.472727h-279.272727v69.818182h200.145455l-358.4 358.4 46.545454 46.545455 358.4-358.4v176.872727H977.454545V111.709091c0-18.618182-13.963636-37.236364-32.581818-37.236364z\" p-id=\"1838\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/share.svg
// module id = BDVe
// module chunks = 31